// Static presentation data parsed from my_database.csv
const presentationsData = [
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "1",
        "slide_name": "Ar Glasses",
        "slide_type": "images",
        "slide_information": "transparent_mode_.jpg",
        "slide_description": "Experience the power of augmented reality glasses in a compact, sunglasses-sized form factor. Built with ARM Cortex-A7 and ESP32-S2 for on-device processing, Miru features an ultra-lightweight design with HDI PCB and 3D-printed components, ensuring durability and efficient performance. This prototype pushes the boundaries of wearable AR technology, blending portability with immersive functionality."
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "1",
        "slide_name": "Dissertation",
        "slide_type": "images",
        "slide_information": "Screenshot_2024-12-06_at_20.55.33.png",
        "slide_description": "University of Nottingham master's dissertation project on remote teleoperation using a VR headset and UR3E robotic arm. The study compares control methods—traditional pendant, desktop interface, and VR (Oculus Quest 2)—evaluating user experience, accuracy, and efficiency. It demonstrates my ability to execute a complete production cycle, from developing the prototype to evaluating its performance through user testing and system analysis, using Unity, ROS2, and Docker for seamless integration."
    },
    {
        "presentation_id": "3",
        "presentation_name": "arm_board",
        "slide_id": "1",
        "slide_name": "STM32MP157_1GB_CUSTOM",
        "slide_type": "images",
        "slide_information": "stm32mp157_front_real.jpg",
        "slide_description": "Custom-engineered STM32MP157 development platform with 1GB RAM, designed for embedded Linux applications. Features a thoughtfully arranged PCB layout with essential peripherals and expansion options, enabling rapid prototyping and development of complex embedded systems. The board combines compact design with comprehensive functionality, making it ideal for both educational and professional projects."
    },
    {
        "presentation_id": "4",
        "presentation_name": "esp32s2",
        "slide_id": "1",
        "slide_name": "ESP32-S2 Custom Board",
        "slide_type": "images",
        "slide_information": "esp32se_front.jpg",
        "slide_description": "Powered by three ESP32-S2 SoCs, the board integrates two cameras and an SPI display connected via an 8-bit communication lane, enabling the processing of dual video streams and delivering the appropriate output. Designed for stereo camera-based applications and the Miru project (Mixed Reality Glasses), this solution emphasizes speed, simplicity, and exceptional power efficiency, making it both versatile and performance-driven."
    },
    {
        "presentation_id": "5",
        "presentation_name": "mistral1",
        "slide_id": "1",
        "slide_name": "Le CopyChat",
        "slide_type": "embeddedLink",
        "slide_information": "https://docs.google.com/presentation/d/e/2PACX-1vR9mOa1JMNA0gIJaPofFDZd8SjzOqL7UCa-d_O9LUvn4_rZ040NkH2l0cMc1tzb0XFj7NtxIUvcocHw/embed?start=false&loop=true&delayms=3000",
        "slide_description": "A robot mimicking human actions from a single video, utilizing the semantic understanding of images powered by large language models, without requiring prior training. This project demonstrates the capabilities of vision-language models to interpret and replicate human movements, creating a more intuitive human-robot interaction paradigm."
    },
    {
        "presentation_id": "6",
        "presentation_name": "hand_gesture",
        "slide_id": "1",
        "slide_name": "Hand Gesture Recognition using Supervised and Unsupervised Machine Learning",
        "slide_type": "embeddedLink",
        "slide_information": "https://drive.google.com/file/d/12td8_YyB9WhXjqegCmC0hE0d13Ey14V7/preview",
        "slide_description": "This assignment explores the use of supervised and unsupervised machine learning algorithms to classify hand gestures based on IMU data collected via smartphone accelerometers. By employing clustering techniques like DBSCAN and K-means, combined with predictive models such as KNN, SVM, and Random Forest, the study identifies the most effective methods for gesture recognition. Through feature extraction, sliding window optimization, and 5-fold cross-validation, Random Forest demonstrated superior accuracy and robustness at a 25% sliding window overlap. This work highlights the potential of integrating machine learning with motion data for intuitive gesture-based applications."
    },
    {
        "presentation_id": "7",
        "presentation_name": "quadpod",
        "slide_id": "1",
        "slide_name": "Quadpod",
        "slide_type": "video",
        "slide_information": "test1.mp4",
        "slide_description": "One of my earliest projects involved a robot attempting to teach itself how to walk autonomously."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "2",
        "slide_name": "Created Multiple lens",
        "slide_type": "images",
        "slide_information": "custom_lens.jpg",
        "slide_description": "Developed a custom lens optimized for both VR and AR applications, enabling an 80% reduction in device size compared to most market alternatives. This compact design maintains high optical performance, ensuring clarity and immersion while enhancing portability and wearability for everyday use."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "3",
        "slide_name": "Focus on form factor",
        "slide_type": "images",
        "slide_information": "sunglasses_with_miruyume.jpg",
        "slide_description": "The design of the glasses prioritized a form factor that closely resembles everyday eyewear. While typical sunglasses have a thickness of approximately 4.5mm, this custom solution achieved a slim 5.6mm profile, including the curvature of the lens. With the right manufacturing equipment, there is potential to further reduce the thickness, bringing it even closer to standard eyewear dimensions."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "4",
        "slide_name": "Thickness and Weight",
        "slide_type": "images",
        "slide_information": "thickness_comparison.jpg",
        "slide_description": "This example highlights the thin and lightweight design of the glasses, closely resembling the profile of standard sunglasses. By excluding batteries from the frame, the design maintains a sleek appearance, making it comfortable and practical for extended wear while preserving the major part of the aesthetics of everyday eyewear."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "5",
        "slide_name": "Augmented Display",
        "slide_type": "video",
        "slide_information": "transparent_lens_working.mp4",
        "slide_description": "An average camera cannot fully capture the capabilities of this display, as it can only focus at a single distance at a time. To truly appreciate the display's performance, compare the strengths of both focus distances shown in the video and mentally combine them. Much like how the human brain processes visual information, it merges relevant details from both focus distances while filtering out inconsistencies. Inspired by the principle behind pinhole eyeglasses, this design enables the human brain to seamlessly overlay the display's pixels onto the real-world environment, creating a unified and immersive visual experience."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "6",
        "slide_name": "AR display",
        "slide_type": "video",
        "slide_information": "fixed_ar_mode.mp4",
        "slide_description": "The AR display mode delivers a wide, unobstructed field of view while maintaining high-quality visuals comparable to specialized displays. This prototype utilizes a 480 x 480 display, commonly found in affordable smartwatches, effectively demonstrating its scalability. By upgrading to higher-resolution displays available in the market, this technology has the potential to create a highly competitive and groundbreaking product."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "7",
        "slide_name": "Adjustable For Varid User Requirements",
        "slide_type": "video",
        "slide_information": "adjustable_lens.mp4",
        "slide_description": "The lens was designed to be simple, lightweight, thin, and cost-effective, catering to a wide range of customers. This was achieved through an adjustable mechanism that allows users to customize the lens to their specific eye requirements with a smooth rotary motion, ensuring both convenience and accessibility."
    },
    {
        "presentation_id": "1",
        "presentation_name": "miruyume",
        "slide_id": "8",
        "slide_name": "It's been a long journey",
        "slide_type": "images",
        "slide_information": "testing_the_idea.jpg",
        "slide_description": "What began as a simple idea—reverse engineering a micro camera and incorporating that knowledge into developing a near-eye display—has evolved into a fully functional prototype. Along this journey, I completed my MSc in Human-Computer Interaction to better understand user needs and refine the final product. This project will continue its development and is set to enter the market as a highly competitive and innovative solution."
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "2",
        "slide_name": "Abstract",
        "slide_type": "text",
        "slide_information": "This dissertation explores the comparative analysis of three control methods—traditional pendant control, desktop interface, and virtual reality (VR) control—using the Oculus Quest 2 for the teleoperation of the UR3E robotic arm. Leveraging a mixed-methods approach, the study evaluates user experience, perceived accuracy, task efficiency, and ease of use across these interfaces. It also investigates system architecture, integrating Unity, ROS2, and Docker-based containerization to enable seamless transitions between simulation and real-robot environments. The findings highlight VR's potential for enhanced immersion in teleoperation while addressing challenges such as cybersickness, system latency, and control precision. Insights from this study contribute to improving robotic control systems and inform future developments in multi-robot control and VR interface optimization.",
        "slide_description": null
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "3",
        "slide_name": "VR Interface",
        "slide_type": "images",
        "slide_information": "PXL_20240902_1326065062.jpg",
        "slide_description": "The VR interface offers an immersive environment for robot control, developed using Unity and connected to a remote Linux system via ROS2. This setup facilitates seamless communication between the VR system and the UR3E robotic arm. To maintain consistency in this comparative study, the interface design mirrored the layout and functions of the desktop and pendant controls. This uniformity ensured that differences in performance and usability were attributed to the control methods rather than interface variations."
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "4",
        "slide_name": "Desktop Interface",
        "slide_type": "images",
        "slide_information": "PXL_20240902_1324576512.jpg",
        "slide_description": "The desktop interface provides a graphical user interface (GUI) for controlling the UR3E robotic arm, offering a balance between familiarity and precision. Developed upon the repository github.com/zhutianqi2006/ur3_unity_ros2_ibvs, it integrates Unity with ROS2 via a TCP connection to enable real-time communication with the robot. The design mirrors the VR and pendant interfaces to ensure consistency in this comparative study. Users interact with the interface using a mouse and keyboard, enabling precise joint manipulation and task execution. The visual feedback on the screen enhances control accuracy, making it intuitive for users familiar with traditional computing environments."
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "5",
        "slide_name": "Pendent Interface",
        "slide_type": "images",
        "slide_information": "PXL_20240902_132430989.jpg",
        "slide_description": "The pendant interface represents a traditional hardware-based control method commonly used in industrial robotics. It features physical buttons and a small display screen for commanding the UR3E robotic arm. This interface allows precise joint manipulation and task execution through predefined key inputs.  While offering high reliability, the physical button layout requires familiarity and can present a steeper learning curve for first-time users. Its tactile feedback supports fine-tuned control, making it suitable for tasks requiring high precision."
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "6",
        "slide_name": "Conclusion",
        "slide_type": "text",
        "slide_information": "My dissertation delves into the exciting intersection of robotics and human-computer interaction, exploring the comparative usability of pendant, desktop, and VR interfaces for teleoperating a UR3E robotic arm. Through rigorous experimentation and a robust system architecture leveraging Unity, ROS2, and Docker containerization, the research highlights the transformative potential of immersive VR interfaces while acknowledging their current challenges, such as latency and cybersickness. The findings not only pave the way for improved user-centric design in robotic control systems but also contribute valuable insights into scalable, real-time teleoperation frameworks. This work underscores the future of robotics—where intuitive control meets technological sophistication.",
        "slide_description": ""
    },
    {
        "presentation_id": "2",
        "presentation_name": "dissertation",
        "slide_id": "7",
        "slide_name": "Paper",
        "slide_type": "pdf",
        "slide_information": "/media/pdfs/Dissertation_final.pdf",
        "slide_description": "Looking for a thrilling way to spend your afternoon? Dive into my dissertation! It's like a novel, but with more graphs, data, and just the right amount of overthinking. Warning: You might want snacks—it's *that* long. 📚😂"
    },
    {
        "presentation_id": "3",
        "presentation_name": "arm_board",
        "slide_id": "2",
        "slide_name": "Beauty with Simplicity",
        "slide_type": "images",
        "slide_information": "stm32mp157_back_real.jpg",
        "slide_description": "\"Any product that needs a manual to work is broken.\" - Elon Musk. The design prioritizes not only functionality but also practicality and simplicity. Featuring a stacked architecture with plug-and-play components, the PCB design eliminates complexity, enabling quick setup with minimal effort. This approach ensures that users require little to no hardware experience, allowing them to focus on seamless software development right out of the box."
    },
    {
        "presentation_id": "3",
        "presentation_name": "arm_board",
        "slide_id": "3",
        "slide_name": "3D model of ARM Cortex A7 Board",
        "slide_type": "embeddedLink",
        "slide_information": "https://gmail786888.autodesk360.com/shares/public/SH35dfcQT936092f0e4390974adbf74ef3ae?mode=embed",
        "slide_description": "3D Render of the Custom PCB Design"
    },
    {
        "presentation_id": "3",
        "presentation_name": "arm_board",
        "slide_id": "4",
        "slide_name": "Schematic",
        "slide_type": "embeddedLink",
        "slide_information": "https://gmail786888.autodesk360.com/shares/public/SH35dfcQT936092f0e43470a12fbf47f025b?mode=embed",
        "slide_description": "Comprehensive schematics of the Cortex-A7 ARM Board, featuring advanced power systems, versatile peripheral integrations, efficient data pathways, and a design focused on modular scalability."
    },
    {
        "presentation_id": "3",
        "presentation_name": "arm_board",
        "slide_id": "5",
        "slide_name": "Brd File",
        "slide_type": "embeddedLink",
        "slide_information": "https://gmail786888.autodesk360.com/shares/public/SH286ddQT78850c0d8a413c30a411cf7d045?mode=embed",
        "slide_description": "A detailed glimpse into the intricate design layout of the circuit board, brought to life through the presented BRD file."
    },
    {
        "presentation_id": "4",
        "presentation_name": "esp32s2",
        "slide_id": "2",
        "slide_name": "Beautiful and Intutive Designs",
        "slide_type": "images",
        "slide_information": "esp32s2_back.jpg",
        "slide_description": "My design philosophy is to create highly efficient and reliable systems while maintaining an aesthetic and functional design. This approach ensures that developers and users can easily read, program, and debug issues—even at the hardware level. Achieving this involves the use of clear labels, symmetrical layouts, and a well-developed hardware architecture that extends beyond the PCB. It also considers debugging tools, programming platforms, and other interaction methods, enabling seamless integration and ease of use."
    },
    {
        "presentation_id": "4",
        "presentation_name": "esp32s2",
        "slide_id": "3",
        "slide_name": "3D model of ESP32S2 display board",
        "slide_type": "embeddedLink",
        "slide_information": "https://gmail786888.autodesk360.com/shares/public/SH35dfcQT936092f0e43115ad8f99c30972d?mode=embed",
        "slide_description": "3D Render of the Custom PCB Design"
    },
    {
        "presentation_id": "4",
        "presentation_name": "esp32s2",
        "slide_id": "4",
        "slide_name": "Schematic",
        "slide_type": "embeddedLink",
        "slide_information": "https://gmail786888.autodesk360.com/shares/public/SH35dfcQT936092f0e43f3e80cff40b379d8?mode=embed",
        "slide_description": "Detailed schematics of the ESP32-S2 Display Board, showcasing power management, camera interfaces, SPI display connections, and a scalable stacked architecture."
    },
    {
        "presentation_id": "4",
        "presentation_name": "esp32s2",
        "slide_id": "5",
        "slide_name": "Brd File",
        "slide_type": "embeddedLink",
        "slide_information": "https://gmail786888.autodesk360.com/shares/public/SH286ddQT78850c0d8a4a9f60d1c9813355e?mode=embed",
        "slide_description": "An immersive view of the ESP32-S2 Display Board's meticulously crafted design layout, showcased through the presented BRD file."
    }
];

export default presentationsData; 